import React, { memo } from 'react'
import Map from 'components/Map'
import useActivities from 'hooks/useActivities'
import { cleanFilters } from 'filters'
import { useRouter } from 'next/router'
import { Box } from '@mui/material'
import Page from 'components/Page'
import sx from './styles'

const MapSection = () => {
  const router = useRouter()

  const params = {
    city__state__slug__in: router?.query?.estado,
    category__slug__in: router?.query?.categoria,
  }

  const activitiesQuery = useActivities(cleanFilters(params))

  return (
    <Page>

      <Box sx={sx.mapContainer}>
        <Map
          items={activitiesQuery?.data}
          variant="map"
        />
      </Box>

    </Page>

  )
}

export default memo(MapSection)
